import React, { useState, useEffect, Fragment } from "react";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { DropdownToggle, DropdownMenu, DropdownItem, Dropdown } from "reactstrap";
import { Table } from "reactstrap";
import { CircularProgress } from "../../UI/CircularProgress/CircularProgress";
import changeAccountIcon from "../../../../public/svg/changeAccount.svg";
import closeSessionIcon from "../../../../public/svg/closeSession.svg";
import { Link } from "react-router-dom";
import { currentAccountSet } from "../../../actions/entities";
import { Icons } from "../../UI/Icon/Icon";
import { Safearea } from "../../UI/Safearea/Safearea";
import { Container } from "../../UI/Container/Container";
import { Col, Row } from "../../UI/Customstrap/Customstrap";
import { fetchGetAccounts } from "../../../services/api/accounts";
import { getSavedPersonInfo, getCurrentAccount, getTexts } from "../../../reducers/selectors";
import greenDotIcon from "../../../../public/svg/SideBarIcons/green-dot.svg";
import { ProfileTestAnswer } from "../../ProfileTestAnswer/ProfileTestAnswer";
import { ProfileTest } from "../../ProfileTest/ProfileTest";
import { signOut } from "../../../actions/auth";
import { Prompt } from "react-router-dom";

import style from "./MyData.scss";
import GenericButton from "../../UI/Button/Button";
import { fetchLastLogin } from "../../../services/api/users";

export const MyData = ({ toggleMyData }) => {
  const personInfo = useSelector(getSavedPersonInfo);
  const [accounts, setAccounts] = useState([]);
  const currentAccount = useSelector(getCurrentAccount);
  const dispatch = useDispatch();
  const [userDropdownIsOpen, setUserDropdownIsOpen] = useState(false);
  const [showProfileAnswers, setShowProfileAnswers] = useState(false);
  const [showRedoTest, setShowRedoTest] = useState(false);
  const [mobilePhone, setMobilePhone] = useState({
    PhoneNumber: "",
  });
  const [personDocument, setPersonDocument] = useState({
    PhysicalPersonDocumentTypeName: "",
    PhysicalPersonDocumentNumber: "",
  });
  const [legalAddress, setLegalAddress] = useState({
    LegalAddressStreet: "",
    LegalAddressCityName: "",
  });
  const [lastLogin, setLastLogin] = useState("");
  const texts = useSelector(getTexts);

  const genderString = {
    N: "No especificado",
    M: "Masculino",
    F: "Femenino",
  };

  const civilStatusString = {
    Single: "Soltero/a",
    Engaged: "Comprometido/a",
    Married: "Casado/a",
    Divorced: "Divorciado/a",
    Widower: "Viudo/a",
  };

  const profileRiskString = {
    Conservative: "Conservador",
    Moderate: "Moderado",
    Aggressive: "Agresivo",
    Aggresive: "Agresivo",
  };

  const profileRiskDescriptionString = {
    Conservative: texts.notes.investor_profile_conservative,
    Moderate: texts.notes.investor_profile_moderate,
    Aggressive: texts.notes.investor_profile_aggressive,
    Aggresive: texts.notes.investor_profile_aggressive,
  };

  async function getLastLogin() {
    const response = await fetchLastLogin();
    if (response.response.result.Code === 200) {
      setLastLogin(response.response.lastLogin);
    }
  }

  useEffect(() => {
    // actualizar datos de persona
    getLastLogin();
    if (personInfo) {
      if (personInfo.Phone.length > 0) {
        const newMobilePhone = personInfo.Phone.find((phoneItem) => phoneItem.PhoneType === "Mobile");
        setMobilePhone((prev) => ({
          ...prev,
          ...newMobilePhone,
        }));
      }

      if (personInfo.Documents.length > 0) {
        const newPersonDocument = personInfo.Documents.find(
          (documentItem) => documentItem.PhysicalPersonDocumentIsMain
        );
        setPersonDocument((prev) => ({
          ...prev,
          ...newPersonDocument,
        }));
      }

      if (personInfo.LegalAddress.length > 0) {
        const newLegalAddress = personInfo.LegalAddress[0];
        setLegalAddress((prev) => ({
          ...prev,
          ...newLegalAddress,
        }));
      }
    }
  }, [currentAccount]);

  useEffect(() => {
    fetchGetAccounts()
      .then((r) => {
        if (r.response.accounts.length > 0) {
          setAccounts(r.response.accounts);
          //handleChangeAccount(r.response.accounts[0]);
        } else {
          handleChangeAccount({
            noAccounts: true,
            AccountNumber: 0,
            AccountEmail: "",
            AccountName: "",
            advisorName: "",
            advisorFirstLastName: "",
            advisorEmail: "",
            advisorPhone: "",
            isPhysical: true,
          });
        }
      })
      .catch((err) => console.error(err));
  }, []);

  const toggleUserDropdown = () => {
    setUserDropdownIsOpen((prevState) => !prevState);
  };

  const handleChangeAccount = (newAccount) => {
    dispatch(currentAccountSet({ ...currentAccount, ...newAccount, AccountNumber: newAccount.number }));
  };

  const toggleShowProfileAnswers = () => {
    setShowProfileAnswers((stateProfileAnswers) => !stateProfileAnswers);
  };

  const toggleShowRedoTest = () => {
    setShowRedoTest((stateRedoTest) => !stateRedoTest);
  };

  const userSelectorData = () => {
    return (
      <Fragment>
        {accounts.map((account, index) => (
          <DropdownItem
            className={style.accountItem}
            key={index}
            onClick={() => {
              handleChangeAccount(account);
              toggleUserDropdown();
            }}
          >
            <img src={greenDotIcon} alt="green-dot" className={style.greenDot} />
            Cuenta {account.number} - {account.name}
          </DropdownItem>
        ))}
      </Fragment>
    );
  };

  if (!personInfo) return <CircularProgress />;

  return (
    <div className={style.subAssetClassDisplay}>
      <Row>
        <Col xs={12} className={style.titleWrapper}>
          <span className={style.iconWrapper} onClick={toggleMyData}>
            <Icons.ArrowLeftIcon className={style.iconArrow} />
          </span>
          <span className={style.titleProfile}>Mi perfil</span>
        </Col>
        <hr />
      </Row>
      <Row>
        <Col>
          <Container className={style.boxPersonalData}>
            <div>
              <p
                className={style.personName}
              >{`${personInfo.PhysicalPersonFirstName} ${personInfo.PhysicalPersonFirstLastName}`}</p>
              <p className={style.account}>
                Cuenta {currentAccount.AccountNumber} - {currentAccount.name}
              </p>
            </div>
            <div className={style.buttonPersonalData}>
              <div className={style.changeAccount}>
                <GenericButton
                  label={"Cambiar cuenta"}
                  rounded
                  padding={"16px 20px 16px 20px"}
                  lineHeight={"28px"}
                  border-radius={"24px"}
                  iconSvg={[{ width: "20px", item: changeAccountIcon }]}
                  handleClick={() => {
                    setUserDropdownIsOpen(!userDropdownIsOpen);
                  }}
                ></GenericButton>
                <Dropdown
                  isOpen={userDropdownIsOpen}
                  toggle={toggleUserDropdown}
                  nav
                  inNavbar
                  className={style.dropdown}
                  tag="ul"
                >
                  <DropdownToggle nav caret className={style.userSelector}>
                    <DropdownMenu className={style.dropDownMenu}>{userSelectorData()}</DropdownMenu>
                  </DropdownToggle>
                </Dropdown>
              </div>
              <GenericButton
                label={"Cerrar sesión"}
                rounded
                padding={"16px 26px 16px 26px"}
                lineHeight={"28px"}
                handleClick={() => {
                  dispatch(signOut());
                  sessionStorage.clear();
                  window.location.reload();
                }}
                iconSvg={[{ width: "20px", item: closeSessionIcon }]}
              ></GenericButton>
            </div>
          </Container>
        </Col>
      </Row>
      {currentAccount.isPhysical ? (
        <Row>
          <Col md={5} className={style.colProfile}>
            <Container className={style.boxProfile}>
              <div>
                <p className={style.title}>Perfil del inversor </p>
                <div className={style.icon}>
                  <Icons.ProfileIcon size="98px 86px"></Icons.ProfileIcon>
                  <p className={style.profileType}>
                    Perfil {profileRiskString[personInfo.PersonProfileRiskName]}
                  </p>
                </div>
                <div className={style.textProfile}>
                  {profileRiskDescriptionString[personInfo.PersonProfileRiskName]}
                </div>
              </div>
              <div className={style.profileButtons}>
                <GenericButton
                  label={"Ver mis respuestas"}
                  padding={"12px 35px 12px 35px"}
                  font-weight={600}
                  backgroundColor={"#E7E5E4"}
                  lineHeight={"24px"}
                  rounded
                  handleClick={toggleShowProfileAnswers}
                  className={style.buttons}
                ></GenericButton>
                <GenericButton
                  label={"Rehacer prueba"}
                  padding={"12px 45px 12px 45px"}
                  font-weight={600}
                  backgroundColor={"#E7E5E4"}
                  lineHeight={"24px"}
                  rounded
                  handleClick={toggleShowRedoTest}
                  className={style.buttons}
                ></GenericButton>
              </div>
            </Container>
          </Col>
          <Col md={7}>
            <Container className={style.wrapperData}>
              <p className={style.title}>Mis datos </p>
              <div className={style.boxData}>
                <div className={style.data}>
                  <div className={style.dataTitle}> Datos personales </div>
                  <div className={style.divider}></div>
                </div>
                <p className={style.info}>
                  <strong>Nombre y apellido: </strong>
                  {`${personInfo.PhysicalPersonFirstName} ${personInfo.PhysicalPersonSecondName} ${personInfo.PhysicalPersonFirstLastName} ${personInfo.PhysicalPersonSecondLastName}`}
                </p>
                <p className={style.info}>
                  <strong>Celular: </strong>
                  {mobilePhone.PhoneNumber}
                </p>
                <p className={style.info}>
                  <strong>Correo electrónico: </strong>
                  {personInfo.PhysicalPersonEmail}
                </p>
                <p className={style.info}>
                  <strong>Dirección: </strong>
                  {`${legalAddress.LegalAddressStreet} ${legalAddress.LegalAddressNumber}, ${legalAddress.LegalAddressCityName}`}
                </p>
                {currentAccount.hasSEN ? (
                  <p className={style.info}>
                    <strong>Número de cuenta comitente: </strong>
                    {`${currentAccount.SEN}`}
                  </p>
                ) : null}
                <p className={style.info}>
                  <strong>Fecha de último ingreso:</strong>
                  {lastLogin ? moment.utc(lastLogin).local().format("DD/MM/YYYY HH:mm:ss") : "-"}
                </p>
              </div>
              <div className={style.boxData}>
                <div className={style.data}>
                  <div className={style.dataTitle}> Documento </div>
                  <div className={style.divider}></div>
                </div>
                <Table className={style.table}>
                  <tbody>
                    <tr>
                      <td>
                        <strong>Tipo de documento: </strong>
                        {personDocument.PhysicalPersonDocumentTypeName}
                      </td>
                      <td>
                        <strong>Número de documento: </strong>
                        {personDocument.PhysicalPersonDocumentNumber}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Género: </strong>
                        {genderString[personInfo.PhysicalPersonGender]}
                      </td>
                      <td>
                        <strong>Estado civil: </strong>
                        {civilStatusString[personInfo.PhysicalPersonCivilStatus]}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Fecha de nacimiento: </strong>
                        {moment(personInfo.PhysicalPersonDateOfBirth).format("DD/MM/YYYY")}
                      </td>
                      <td>
                        <strong>Lugar de nacimiento: </strong>
                        {`${personInfo.PhysicalPersonCityOfBirthName}`}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
              <div className={style.boxData}>
                <div className={style.data}>
                  <div className={style.dataTitle}> Ocupación </div>
                  <div className={style.divider}></div>
                </div>
                <Table className={style.table}>
                  <tbody>
                    <tr>
                      <td>
                        <strong>Ocupación: </strong>
                        {personInfo.PersonProfessionName}
                      </td>
                      <td>
                        <strong>Ciudad (laboral): </strong>
                        {legalAddress.LegalAddressCityName}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Nombre de la empresa: </strong>
                        {personInfo.PhysicalPersonInstitution}
                      </td>
                      <td>
                        <strong>Actividad del negocio: </strong>
                        {personInfo.PersonActivitySectorName}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Container>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col>
            <Container className={style.wrapperData}>
              <p className={style.title}>Datos </p>
              <div className={style.boxData}>
                <p className={style.info}>
                  <strong>Nombre de la empresa: </strong>
                  {currentAccount.companyJuridicalName}
                </p>
                <p className={style.info}>
                  <strong>RUC: </strong>
                  {currentAccount.juridicalDoc}
                </p>
                <p className={style.info}>
                  <strong>Domicilio: </strong>
                  {currentAccount.companyLegalAdress}
                </p>
                <p className={style.info}>
                  <strong>Ciudad: </strong>
                  {currentAccount.companyCity}
                </p>
                <p className={style.info}>
                  <strong>País: </strong>
                  {currentAccount.companyCountry}
                </p>
                <p className={style.info}>
                  <strong>Teléfono: </strong>
                  {currentAccount.companyBussinesPhone}
                </p>
                {currentAccount.hasSEN ? (
                  <p className={style.info}>
                    <strong>Número de cuenta comitente: </strong>
                    {`${currentAccount.SEN}`}
                  </p>
                ) : null}
              </div>
            </Container>
          </Col>
        </Row>
      )}
      <Prompt
        when={showProfileAnswers}
        message={(location) => {
          toggleShowProfileAnswers();
          // No permitir la navegación hacia atrás
          return false;
        }}
      />
      <Prompt
        when={showRedoTest}
        message={(location) => {
          toggleShowRedoTest();
          // No permitir la navegación hacia atrás
          return false;
        }}
      />
      {showProfileAnswers && <ProfileTestAnswer toggleProfileAnswers={toggleShowProfileAnswers} />}
      {showRedoTest && <ProfileTest toggleRedoTest={toggleShowRedoTest} />}
    </div>
  );
};
